import React, { FunctionComponent } from 'react';
import styles from '../styles.module.scss';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Dealer } from '../../../types/dealerTypes';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import { Checkbox } from '../../Input/Checkbox/Checkbox';
import { DealerLaunchStepProps } from '../types';
import { Button } from '../../Input/Button/Button';

const REVIEW_FORMS = [
  {
    name: 'Confirm that your printer supports airprint',
    formName: 'launchpad.printSetup.isAirprintSupported',
    description:
      'We rely on Apple AirPrint for all printing from within our app. ',
  },
  {
    name: 'Ensure that your ipad and printer are using the same wifi network',
    formName: 'launchpad.printSetup.isOnSameWifiNetwork',
    description:
      'Please setup your own SSID (unique network) for the printers and ipads. Make sure that this is password protected',
  },
  {
    name:
      'Open the Upstart Auto Retail App and select a form from the forms library to review',
    formName: 'launchpad.printSetup.hasFormLibrarySelected',
    description: 'You do not need to fill in the form to print it',
  },
  {
    name: `When ready, hit 'save and print form'`,
    formName: 'launchpad.printSetup.isPrintReady',
    description:
      'This will save your information and generate a printable form.',
  },
  {
    name: `Hit 'print' and select your printer form the menu to run a test print`,
    formName: 'launchpad.printSetup.hasTestPrintSelected',
    description:
      'We recommend running a test print to ensure that the printer is working.',
  },
];

export const DealerLaunchInstorePrintingSetup: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });

  const handleTestPrint = () => {
    if (window) {
      const myWindow: any = window.open('', 'PRINT', 'height=600,width=600');

      const template = `
        <html>
          <head>
            <title>${document.title}</title>
          </head>
          <body>
            <h1>TEST</h1>
          </body>
        </html>
      `;
      myWindow.document.write(template);

      myWindow.document.close();
      myWindow.focus();

      myWindow.print();
      myWindow.close();
    }
  };

  const onSubmit = async () => {
    const { launchpad } = form.getValues();
    const partialDealerUpdate = {
      launchpad: {
        printSetup: {
          ...launchpad?.printSetup,
        },
        status: {
          finishedPrintingSetup: true,
        },
      },
    };
    await nextStep({
      ...partialDealerUpdate,
    });
  };

  return (
    <DealerLaunchFormCardLayout
      className={styles.formsStep}
      form={form}
      title="Let's Review Your Printing Setup"
      subTitle=""
      nextLabel="Save and Continue"
      prevStep={prevStep}
      onFormSubmit={onSubmit}
    >
      {REVIEW_FORMS.map((formEntry, idx) => (
        <div className={styles.reviewFormContainer}>
          <Checkbox
            key={formEntry.name}
            label={formEntry.name}
            name={formEntry.formName as never}
            form={form}
          />
          <span className={styles.description}>
            {formEntry.description}
            {idx === 0 && (
              <Button variant="minimal" onClick={handleTestPrint}>
                Check here to see if your printer supports AirPrint.
              </Button>
            )}
          </span>
        </div>
      ))}
    </DealerLaunchFormCardLayout>
  );
};
